import { createContext } from 'react';

export const UserContext = createContext({});
export const GroupsContext = createContext({});
export const CsrfContext = createContext('');
